import { Button, Modal } from "react-bootstrap";
import type { CSSProperties } from "react";

type ConfirmActionModalProps = {
    show: boolean;
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onClose: () => void;
    isLoading?: boolean;
    /** Shown in place of a silent failure, so a refused action says why. */
    error?: string | null;
    className?: string;
    backdropClassName?: string;
    style?: CSSProperties;
};

export default function ConfirmActionModal({
    show,
    title,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    onConfirm,
    onClose,
    isLoading = false,
    error = null,
    className,
    backdropClassName,
    style,
}: ConfirmActionModalProps) {
    return (
        <Modal
            centered
            show={show}
            onHide={isLoading ? undefined : onClose}
            backdrop={isLoading ? "static" : true}
            keyboard={!isLoading}
            className={className}
            backdropClassName={backdropClassName}
            style={style}
        >
            <Modal.Header closeButton={!isLoading}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
                {error && (
                    <div className="text-danger mt-2" role="alert">
                        {error}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onClose} disabled={isLoading}>
                    {cancelLabel}
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
                    {isLoading ? "Working..." : confirmLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
